module.exports = __webpack_public_path__ + "img/phone-x1.a191d57c.svg";